import { createFileRoute } from '@tanstack/react-router';
import { FeatureRequestsPage } from '@pages/feature-requests';

/** Feature-Requests-Route (/feature-requests) */
export const Route = createFileRoute('/_authenticated/feature-requests')({
  component: FeatureRequestsPage,
});
